module.exports = __webpack_public_path__ + "static/media/eva_minus-circle-outline.d8edac5e.svg";